import { Component } from '@angular/core';

@Component({
  selector: 'app-chart-loading',
  standalone: true,
  templateUrl: './chart-loading.component.html',
  styleUrls: ['./chart-loading.component.scss']
})
export class ChartLoadingComponent {}
